import {
    APPLE_PAY_GET_SESSION,
    APPLE_PAY_GET_SESSION__SUCCESS,
    APPLE_PAY_GET_SESSION__FAILURE,
    APPLE_PAY_GET_SESSION__RESET,

    APPLE_PAY_VALIDATE_MERCHANT,
    APPLE_PAY_VALIDATE_MERCHANT__SUCCESS,
    APPLE_PAY_VALIDATE_MERCHANT__FAILURE,
    APPLE_PAY_VALIDATE_MERCHANT__RESET,

    APPLE_PAY_PAYMENT_AUTHORIZED,
    APPLE_PAY_PAYMENT_AUTHORIZED__SUCCESS,
    APPLE_PAY_PAYMENT_AUTHORIZED__FAILURE,
    APPLE_PAY_PAYMENT_AUTHORIZED__RESET,

    APPLE_PAY__RESET,
} from './actions';

const initialState = {
    appleSession: {
        data: {},
        isLoading: false,
        isLoaded: false,
        error: null,
    },
    appleValidation: {
        data: {},
        isLoading: false,
        isLoaded: false,
        error: null,
    },
    appleAuthorized: {
        data: {},
        isLoading: false,
        isLoaded: false,
        error: null,
    },
};
export default function AppleReducer(state = initialState, action = {}) {
    switch (action.type) {
        case APPLE_PAY_GET_SESSION: {
            return {
                ...state,
                appleSession: {
                    data: {},
                    isLoading: true,
                    isLoaded: false,
                    error: null,
                },
            };
        }
        case APPLE_PAY_GET_SESSION__SUCCESS: {
            return {
                ...state,
                appleSession: {
                    data: action.data,
                    isLoading: false,
                    isLoaded: true,
                    error: null,
                },
            };
        }
        case APPLE_PAY_GET_SESSION__FAILURE: {
            return {
                ...state,
                appleSession: {
                    data: {},
                    isLoading: false,
                    isLoaded: false,
                    error: action.error,
                },
            };
        }
        case APPLE_PAY_GET_SESSION__RESET: {
            return {
                ...state,
                appleSession: {
                    ...initialState.appleSession,
                },
            };
        }

        case APPLE_PAY_VALIDATE_MERCHANT: {
            return {
                ...state,
                appleValidation: {
                    data: {},
                    isLoading: true,
                    isLoaded: false,
                    error: null,
                },
            };
        }
        case APPLE_PAY_VALIDATE_MERCHANT__SUCCESS: {
            return {
                ...state,
                appleValidation: {
                    data: action.data,
                    isLoading: false,
                    isLoaded: true,
                    error: null,
                },
            };
        }
        case APPLE_PAY_VALIDATE_MERCHANT__FAILURE: {
            return {
                ...state,
                appleValidation: {
                    data: {},
                    isLoading: false,
                    isLoaded: false,
                    error: action.error,
                },
            };
        }
        case APPLE_PAY_VALIDATE_MERCHANT__RESET: {
            return {
                ...state,
                appleValidation: {
                    ...initialState.appleValidation,
                },
            };
        }

        case APPLE_PAY_PAYMENT_AUTHORIZED: {
            return {
                ...state,
                appleAuthorized: {
                    data: {},
                    isLoading: true,
                    isLoaded: false,
                    error: null,
                },
            };
        }
        case APPLE_PAY_PAYMENT_AUTHORIZED__SUCCESS: {
            return {
                ...state,
                appleAuthorized: {
                    data: action.data,
                    isLoading: false,
                    isLoaded: true,
                    error: null,
                },
            };
        }
        case APPLE_PAY_PAYMENT_AUTHORIZED__FAILURE: {
            return {
                ...state,
                appleAuthorized: {
                    data: {},
                    isLoading: false,
                    isLoaded: false,
                    error: action.error,
                },
            };
        }
        case APPLE_PAY_PAYMENT_AUTHORIZED__RESET: {
            return {
                ...state,
                appleAuthorized: {
                    ...initialState.appleAuthorized,
                },
            };
        }

        case APPLE_PAY__RESET: {
            return {
                ...state,
                appleAuthorized: {
                    ...initialState.appleAuthorized,
                },
                appleValidation: {
                    ...initialState.appleValidation,
                },
                appleSession: {
                    ...initialState.appleSession,
                },
            };
        }

        default: {
            return state;
        }
    }
}
